var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { CompanyDetail } from "./../models/V1/Companies/CompanyInfo/CompanyDetail";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class Company {
  /**
   * Creates an instance of Company.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof Company
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetCompanyDetailRq_ _getCompanyDetailRq
   * @returns Promise<GetCompanyDetailRq_>
   * @memberof Company
   */
  getCompanyDetail(pGetCompanyDetailRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Company/Company/Details", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addQueryParams([{ name: "locale", value: pGetCompanyDetailRq.locale }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: CompanyDetail },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
